import { useEffect, useState } from "react";
import { BiSolidFilePlus, BiSolidLayerPlus } from "react-icons/bi";
import { notifyError } from "../../utils/notify";

export function BoardcastForm({ onSubmit, initialData }) {
    const [formData, setFormData] = useState({
        name: initialData?.name || "",
        forward_list: initialData?.forward_list || "",
    });

    useEffect(() => {
        setFormData({
            name: initialData?.name || "",
            forward_list: initialData?.forward_list || [],
        });
    }, [initialData]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (formData.name === "") {
            notifyError("Name is required");
            return;
        }

        onSubmit(formData);
        setFormData({
            name: "",
            forward_list: "",
        });
    };

    return (
        <div className="pt-6">
            <form onSubmit={handleSubmit} className="space-y-4">
                {/** Save */}
                <div className="flex justify-start">
                    <button type="submit" className="bg-yellow-500 text-white px-4 py-2 rounded-lg">Save</button>
                </div>
                {/* Name */}
                <div>
                    <label className="block text-sm font-medium text-gray-700">Name</label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="w-full px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:outline-none"
                    />
                </div>

                {/* Forword List */}
                <div>
                    {/** Forward list heading */}
                    <div className="flex items-center space-x-2">
                        <div className="w-1/3">Forward To</div>
                        <div className="w-1/3">Forward Port</div>
                        <div className="w-1/3">Forward Enabled</div>
                    </div>
                    {formData?.forward_list && formData?.forward_list?.map((item, index) => (
                        <div key={index} className="flex items-center space-x-2">
                            {/* {
                                "id": "f2568449-ba4d-45f3-98b9-d7517a19a6db",
                                "pingstation_id": "123",
                                "forward_to": "127.0.0.1",
                                "forward_port": 40023,
                                "forward_enabled": true,
                                "group_id": "68e8bce8-fc67-490b-b951-ea688fc506ae",
                                "created_at": "2025-01-03T12:56:30.751Z",
                                "updated_at": "2025-01-03T12:56:30.751Z"
                            } */}
                            <input type="text" name="forward_to" value={item.forward_to} onChange={(e) => {
                                const value = e.target.value;
                                setFormData((prev) => ({
                                    ...prev,
                                    forward_list: prev.forward_list.map((i, j) => (j === index ? { ...i, forward_to: value } : i)),
                                }));
                            }} className="w-1/3 px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:outline-none" />

                            <input type="number" name="forward_port" value={item.forward_port} onChange={(e) => {
                                const value = e.target.value;
                                setFormData((prev) => ({
                                    ...prev,
                                    forward_list: prev.forward_list.map((i, j) => (j === index ? { ...i, forward_port: value } : i)),
                                }));

                            }} className="w-1/3 px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:outline-none" />

                            <input type="checkbox" name="forward_enabled" checked={item.forward_enabled} onChange={(e) => {
                                const value = e.target.checked;
                                console.log({value, index, list: formData?.forward_list.map((i, j) => (j === index ? { ...i, forward_enabled: value } : i))})
                                setFormData((prev) => ({
                                    ...prev,
                                    forward_list: prev.forward_list.map((i, j) => (j === index ? { ...i, forward_enabled: value } : i)),
                                }));
                            }} className="w-1/3 px-4 py-2 mt-1 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:outline-none" />
                            <button
                                type="button"
                                onClick={() =>
                                    setFormData((prev) => ({
                                        ...prev,
                                        forward_list: prev.forward_list.filter((_, i) => i !== index),
                                    }))
                                }
                                className="text-red-500"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M10 0c5.52 0 10 4.48 10 10s-4.48 10-10 10S0 15.52 0 10 4.48 0 10 0zm5 11.41L14.41 15 10 10.59 5.59 15 4 13.41 8.41 9 4 4.59 5.59 3 10 7.41 14.41 3 16 4.59 11.59 9 16 13.41z"
                                    />
                                </svg>
                            </button>
                        </div>
                    ))}

                    {/* Add Forward */}
                    <div className="flex justify-end">
                    <button
                        type="button"
                        onClick={() =>
                            setFormData((prev) => ({
                                ...prev,
                                forward_list: [...prev.forward_list, { forward_to: "", forward_port: 0, forward_enabled: false }],
                            }))
                        }
                        className="bg-green-500 text-2xl mt-2 text-white px-4 py-2 rounded-lg flex items-center justify-center"
                    >
                        <BiSolidFilePlus /> <span className="text-base ml-2">Add Row</span>
                    </button>
                    </div>
                </div>

                {/* <button type="submit" className="w-full py-2 px-4 bg-yellow-500 text-white rounded-lg">
                    Submit
                </button> */}
            </form>
        </div>
    );

}